var i={serviceAvia:"icon-flight-to-top",serviceRail:"icon-train",serviceHotel:"icon-building",serviceTransfer:"icon-bus",serviceAdditional:"icon-additional",serviceTicketsOperations:"icon-ticket"};export{i as REQUEST_ICONS};
